import ApiService from '../apiservice'

export default class UnidadeAtendimentoService extends ApiService {

  constructor() {
    super('/unidade-atendimento')
  }

  listar(empresaId) {
    return this.get(`/${empresaId}`);
  }
}
